import { render, staticRenderFns } from "./modal-v2.vue?vue&type=template&id=617e8901&lang=pug&"
import script from "./modal-v2.vue?vue&type=script&lang=js&"
export * from "./modal-v2.vue?vue&type=script&lang=js&"
import style0 from "./modal-v2.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports